/* decision point */
import { Medscape } from '../../medscape';
import { DecisionPointShare } from './decision-point-share';
import { CommonSVPLoadModule as SVPLoader } from '../../modules/svpload/common-svp-load-module';
import { StickyVideo } from '../promos-articles/modules/common/sticky-video/sticky-video';
import { PlayListAPI } from '../promos-articles/modules/recap/filmstrip/recap-filmstrip';
import { CloseCaptionReconfig } from '../promos-articles/modules/recap/close-caption';
import { DP_DirectIFI } from './dp-direct-ifi';
import { WatchListFabButton } from '../promos-articles/modules/save-video/watchlist-fab-button';
import { VideoSaver } from '../promos-articles/modules/save-video/save-video.js';

window.performance.mark('eedDP_start', {
	detail: "Page loaded Decision point called",
});
const MAX_RELATED_ARTICLES = 10; // We only show 10 articles in related articles widget
const domain = getDomain();
const BASE_URL_DP_SELECTION_PATH_API = '//api.' + domain + 'medscape.com/' + 'contentmetadataservice/decisionpoint/ODP/type/';
const BASE_URL_DP_ARTICLE_API = '//api.' + domain + 'medscape.com/' + 'contentmetadataservice/decisionpoint/article/';
var specialityUrl;
window.filmStripCreated = false;
window.injectIFIwithNowPlaying = false;
window.currentArticleVideoData = {};
const typeUrlParam = window.location.pathname.indexOf('oncology') > -1 ? 'ctype' : 'type';
const subTypeUrlParam = window.location.pathname.indexOf('oncology') > -1 ? 'ttype' : 'subtype';
const dpShareTools = new DecisionPointShare();
const sticky = new StickyVideo("#cme-video-player", $("h1.title").text());
const ccReconfig = new CloseCaptionReconfig();
window.wmdTrackSafe = (modval, elem) => {
	try {
		wmdTrack(modval, elem);
	} catch(e) {
		console.log(e);
	}
};

window.wmdPageLinkSafe = (modval, elem) => {
	try {
		wmdPageLink(modval, elem);
	} catch(e) {
		console.log(e);
	}
}
window.addEventListener('message', function(e) { 
	let message = typeof e.data == "string" && e.data.indexOf("loadIfiVideo") > 0 ? JSON.parse(e.data) :"";
	if(message.callback && message.callback == "loadIfiVideo") {
		window.Medscape.DecisonPoint.loadSponsoredVideo(message['payload']);
	}
});

let playListApi = new PlayListAPI();
//TODO add this function to a common place library file
function getUrlParameter(sParam) {
	
      var  sPageURL = decodeURIComponent(window.location.search.substring(1)),
			sURLVariables = sPageURL.split('&'),
			sParameterName,i;
			for (i = 0; i < sURLVariables.length; i++) {
				sParameterName = sURLVariables[i].split('=');
				if (sParameterName[0] === sParam) {
					return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
				}
			}
}

//PPE-300906 DP Affiliate Page Rebranding on articles
//method to create referrer cookie, update the sf no, and change the branding image
const dpAffiliateRebrand = () => {
	//get ecd query param and pass into function
	let ecdString = getUrlParameter('ecd');
	if (typeof ecdString !== 'undefined' && ecdString !== null) {
		//check if ecd string param is for mdedge or mdalert
		if (ecdString.split('_')[2] === 'medp' || ecdString.split('_')[2] === 'madp') {
			//get referrerVal and set cookie
			let referrerVal = ecdString.split('_')[2];
			window.sessionStorage.setItem('referrerVal', referrerVal);
			//get sfNo and set cookie
			let sfNo = ecdString.split('_')[3];
			if (typeof sfNo !== 'undefined') {
				sfNo = sfNo.replace('-', '.');
			}
			window.sessionStorage.setItem('sfNo', sfNo);
			//update act id if it exists on the page
			if (typeof promoActivity !== 'undefined') {
				if (typeof promoActivity.salesforceNumber !== 'undefined' && promoActivity.salesforceNumber !== '') {
					if (promoActivity.salesforceNumber === '398394.1') {
						promoActivity.salesforceNumber = sfNo;
						window.s_sact = sfNo;
						//replace image
						$('.dp-title-block').addClass(referrerVal);
					}
				}
			}
			else {
				if (typeof window.s_sact !== 'undefined' && window.s_sact !== '') {
					if (window.s_sact === '398394.1') {
						window.s_sact = sfNo;
						//replace image
						$('.dp-title-block').addClass(referrerVal);
					}
				}
			}
		}
	}
//if there is no ecd query param and sfno and referrerval are set in session storage, update logo
	else {
		if (typeof promoActivity !== 'undefined') {
			if (window.sessionStorage.getItem('referrerVal') !== null && window.sessionStorage.getItem('sfNo') !== null && typeof promoActivity.salesforceNumber !== 'undefined') {
				if (promoActivity.salesforceNumber === '398394.1') {
					promoActivity.salesforceNumber = window.sessionStorage.getItem('sfNo');
					window.s_sact = window.sessionStorage.getItem('sfNo');
					//replace image
					$('.dp-title-block').addClass(window.sessionStorage.getItem('referrerVal'));
				}
			}
		}
		else {
			if (window.sessionStorage.getItem('referrerVal') !== null && window.sessionStorage.getItem('sfNo') !== null && typeof window.s_sact !== 'undefined') {
				if (window.s_sact === '398394.1') {
					window.s_sact = window.sessionStorage.getItem('sfNo');
					//replace image
					$('.dp-title-block').addClass(window.sessionStorage.getItem('referrerVal'));
				}
			}
		}
	}
//make sure updated s_sact value is passed into ads call
	if (typeof window.s_sact !== 'undefined') {
		if (window.s_sact !== '') {
			webmd.ads2.setPageTarget('dseg', window.s_sact);
		}
		//pass in 0 for blank values
		else {
			webmd.ads2.setPageTarget('dseg', 0);
		}
	}
}

//PPE-300906 DP Affiliate Page Rebranding on articles
dpAffiliateRebrand();

// Function to get parameters for related videos request
const getParamForRelatedWidget = () => {
	const _type = getUrlParameter(typeUrlParam) ? getUrlParameter(typeUrlParam).replace(/\+/g, ' ') : "";
	const _subType = getUrlParameter(subTypeUrlParam) ? getUrlParameter(subTypeUrlParam).replace(/\+/g, ' ') : "";

	let urlElements = decodeURIComponent(window.location.search).replace(/\+/g, ' ').split("&");
	const dpName = window.DFPTargetKeys.pageSegVars.dpt ? window.DFPTargetKeys.pageSegVars.dpt.split(",")[0] : "";
	let _urlParam = "";
	if (!dpName) {
		return ""
	}

	if (_type && _subType) {
		_urlParam = `?dpName=${dpName}&typeName=${_type}&subtypeName=${_subType}`;
	}
	if (_type && _subType && urlElements.length > 2) {
		var _treeSelections = "";
		urlElements.splice(0, 2);
		// _treeSelections = urlElements.reduce((acc, e) => {
		// 	if (e.split("=")[1] && e.split("=")[1] != "undefined") {
		// 		return acc += (urlElements.length - 1 == urlElements.indexOf(e)) ? e.split("=")[1] : `${e.split("=")[1]};`;
		// 	}
		// }, "");
		for (let __i = 0; __i < urlElements.length; __i++) {
			const additionalParam = urlElements[__i].split("=");
			if (additionalParam[1] && additionalParam[1] != "undefined" && urlElements[__i].indexOf('icd') < 0) {
				_treeSelections += `${additionalParam[1]};`;
			}
		}
		if (_treeSelections) {
			console.log(`returning with selections ${_treeSelections}`)
			_urlParam = `${_urlParam}&params=${_treeSelections}`;
			return _urlParam;
		} else {
			console.log(`no selections ${_treeSelections}`);
			return _urlParam;
		}
		
		
	} else {
		return _urlParam;
	}
}

const getArticleIdFromUrl = () => {
	let articleId;
	if (window.location.href.split('viewarticle/').length > 1) {
		articleId = window.location.href.split('viewarticle/')[1];
		if(articleId.indexOf("?") > -1) {
			articleId = articleId.split("?")[0];
		}
	} else {
		throw "URL Parsing Error.";
	}
	return articleId;
}

//Get decision point, type and subtype
function setGobackUrlForNoParam(articleId) {
    const articleUrl = BASE_URL_DP_ARTICLE_API + articleId + '/paths';
    let articleTags;
	$.ajax({
		url: articleUrl,
				success: function(result) {
					articleTags = result;
				}
		}).done(function() {
				const path = articleTags.decisionPath;
				if (path && path.length > 0) {
					const pathArr = path[0].decision_path.split('|');
					const selectedType = pathArr[1];
					const selectedSubtype = pathArr[2];
					const backUrl = encodeURI(`${specialityUrl}?${typeUrlParam}=${selectedType}&${subTypeUrlParam}=${selectedSubtype}`);
					$('div.breadcrumb > a:nth-child(5)').attr('href', backUrl);
				 } else {
					 throw "Error in fetching decison path for the specified article";
				 }
		});
}

const renderRelatedArticlesForNoParamArticle = (articleId) => {
	const articleUrl = BASE_URL_DP_ARTICLE_API + articleId + '/paths';
	let articleTags;
	$.ajax({ 
		url: articleUrl,
				success: function(result) {
					articleTags = result;
				}
		}).done(function() {
				const path = articleTags.decisionPath;
				if (path && path.length > 0) {
					const pathArr = path[0].decision_path.split('|');
					const selectedType = pathArr[1];
					const selectedSubtype = pathArr[2];
					const articleUrl = BASE_URL_DP_SELECTION_PATH_API + selectedType.replace(/\+/g, ' ') + '/subtype/' + selectedSubtype + '/articles?path=';
					let relatedArticles; //http://api.qa01.medscape.com/contentmetadataservice/decisionpoint/getrelated/896725

					$.ajax({ 
						url: articleUrl,
								success: function(result){
							        relatedArticles = result;
								}
						}).done(function() {
							if (relatedArticles.articles) {
								// Only show 10 articles per Chris
								renderRelatedWidget(relatedArticles.articles.splice(0, MAX_RELATED_ARTICLES));
							}
					});
				 } else {
					 throw "Error in fetching decison path for the specified article";
				 }
		});
};

//For the viewarticle page to navigate back
function setGobackUrl() {
	// If no type and subtype found, then a plain article page should direct users to 
	// tree page, PPE-191372
		
	let decodedLink = decodeURIComponent(window.location.href);
		
	if (decodedLink.indexOf(`${typeUrlParam}=`) === -1 && decodedLink.indexOf(`${subTypeUrlParam}=`) === -1) {
		
		const articleId = getArticleIdFromUrl();
		setGobackUrlForNoParam(articleId);
	}
	
	//if (getUrlParameter('ctype') && getUrlParameter('ttype')) {
	if (getUrlParameter(typeUrlParam) && getUrlParameter(subTypeUrlParam)) {
		const backUrl = decodeURIComponent(`${specialityUrl}?${window.location.href.split('?')[1].split('+').join(' ')}`);
		// Remove url parameters starting with # from the URL
		let backUrlWithout = backUrl.split('#')[0];
		// Remove '&' from the end of the url
		backUrlWithout = backUrlWithout[backUrlWithout.length - 1] == "&" ? backUrlWithout.substring(0, backUrlWithout.length - 1): backUrlWithout;
		$('div.breadcrumb > a:nth-child(5)').attr('href', backUrlWithout);
	}
} 

// Below finction will add now playing video in the film strip
function addNowPlayingVideo() {
	var timeIntervals = [0, 25, 50, 75];
	var videoFinished = false;
	const articletextFull = $("title").eq(0).text();
	const articletext = truncateArticleTitle(articletextFull);	
	let bumperImage  =  $('#videoContent img').length > 0 ? $('#videoContent img').attr('src'):"";
	if (!bumperImage) {
		bumperImage = window.currentThumbnail;
	}
	let nowPlayingVideo =  `<div class='filmStrip-card carousel-cell current-video'>
	<div class="label playing">NOW PLAYING</div>
	<div class='video-teaser'><img alt="${articletext}" src=${bumperImage}></div>
	<div class='filmStrip-card-title'>${playListApi.enhanceTitleForViewability(articletext)}</div></div>`;
	if( window.injectIFIwithNowPlaying ) {
		nowPlayingVideo += window.ifiVideoHtmlString;
	}
	$('div.filmStrip').prepend(nowPlayingVideo);
	// Add event listner to current video player
	$(".current-video").on("click", function () {
		if (window.currentArticleVideoData.videoId != window.myVideoPlayer.amp.media.metadata.videoId) {
			$(".current-video .label.playing").show();
			$(".ifi-card .label.playing").hide();
			window.myVideoPlayer.setMedia(window.currentArticleVideoData);
			$('.article-wrapper').show();
			sticky.setStickyTitle(articletext)
			sticky.setIFIVideo(window.sponsoredVideoData["title"], ".ifi-card");
		}
		if($(".sponsored-html-content").length > 0) {
			$(".sponsored-html-content").hide();
			$(".sponsored-meta-data").hide();
		}
	});
	// Filmstip carousel creation
	window.EEDflkty = new Flickity( '.filmStrip', 
		{
			cellAlign: 'left',
			pageDots: false,
			draggable: false
		}
	);
	if( window.injectIFIwithNowPlaying ) {
		$(".ifi-card").on("click", function () {
			if (window.sponsoredVideoData.video.videoId != window.myVideoPlayer.amp.media.metadata.videoId) {
				$(".current-video .label.playing").hide();
				$(".ifi-card .label.playing").show();	
				window.myVideoPlayer.setMedia(window.sponsoredVideoData.video);
				if (typeof window.sponsoredVideoData.video.trackingPixel == "string") {
					loadTrackingPixel(window.sponsoredVideoData.video.trackingPixel);
				}
				const nextVideoUrl = location.origin + `${specialityUrl}/viewarticle/` + window.nextVideo["articleId"];
				sticky.setStickyTitle(window.sponsoredVideoData,true)
				sticky.setNextVideo(nextVideoUrl , window.nextVideo["articleTitle"]);
				addIsiBeforeTheFilmStrip();
				$('.article-wrapper').hide();
			}
		});
	}
	window.filmStripCreated = true;
	window.currentArticleVideoData = window.myVideoPlayer.playerSettings;
	// Added event listener to video for multiple tracking pixels 
	window.myVideoPlayer.amp.addEventListener("timeupdate",function(_e){
		let {
			currentTime,
			duration
		} = _e.player;
		let timePercent = (currentTime / duration) * 100;
		if (window.myVideoPlayer.amp.media.metadata.videoId && window.sponsoredVideoData && window.sponsoredVideoData.video.videoId && window.myVideoPlayer.amp.media.metadata.videoId == window.sponsoredVideoData.video.videoId) {
			timeIntervals.forEach((element, i) => {
				if (timePercent > element) {
					timeIntervals.splice(i, 1);
					if (element == 0 && window.sponsoredVideoData.video[`trackingPixel-Start`]) {
						loadTrackingPixel(window.sponsoredVideoData.video[`trackingPixel-Start`]);
					}
					else if (window.sponsoredVideoData.video[`trackingPixel-${element}`]) {
						loadTrackingPixel(window.sponsoredVideoData.video[`trackingPixel-${element}`]);
					}
				}
			});
		}
	});
	window.myVideoPlayer.amp.addEventListener("ended", function(params) {
			autoPlayIFIVideo();
			if (window.sponsoredVideoData) {
				if (window.myVideoPlayer.amp.media.metadata.videoId && window.sponsoredVideoData &&
					window.sponsoredVideoData.video.videoId	&& window.myVideoPlayer.amp.media.metadata.videoId == window.sponsoredVideoData.video.videoId) {
					loadTrackingPixel(window.sponsoredVideoData.video[`trackingPixel-100`]);
					autoPlayNextVideo();
				}
			}
			else {
				autoPlayNextVideo();				
			}
		// Added event listener to video for add track pixel at end of the video
	});
	//document.getElementsByClassName('akamai-media-element')[0].addEventListener('ended',autoPlayIFIVideo,false);
	addWatchListButton();
}

// Function to auto play the IFI after now playing
function autoPlayIFIVideo () {
	if(window.sponsoredVideoData && window.sponsoredVideoData.video.videoId != window.myVideoPlayer.amp.media.metadata.videoId) {
		$(".current-video .label.playing").hide();
		$(".ifi-card .label.playing").show();
		window.myVideoPlayer.setMedia(window.sponsoredVideoData.video);
		$('.article-wrapper').hide();
		addIsiBeforeTheFilmStrip();
		if (typeof window.sponsoredVideoData.video.trackingPixel == "string") {
			loadTrackingPixel(window.sponsoredVideoData.video.trackingPixel);
		}
		const nextVideoUrl = location.origin + `${specialityUrl}/viewarticle/` + window.nextVideo["articleId"];
		sticky.setStickyTitle(window.sponsoredVideoData,true)
		sticky.setNextVideo(nextVideoUrl , window.nextVideo["articleTitle"]);
	}
}

// Function to add ISI when IFI is palyed 
function addIsiBeforeTheFilmStrip() {
	if ($(".sponsored-html-content").length == 0) {
		if (window.sponsoredVideoData && window.sponsoredVideoData['html-content']) {
			const { "html-content": htmlContent, theme, title } = window.sponsoredVideoData;
			const isiHtmlContent = `<div class="sponsored-html-content">
									${htmlContent}
								</div>
								<div class="sponsored-meta-data">
									<div class="label">Information From Industry</div>
									<div class="title">${title}</div>
								</div>`;
			$("div.filmStrip").before(isiHtmlContent);
		}
	} else {
		$(".sponsored-html-content").show();
		$(".sponsored-meta-data").show();
	}
}

// Function to add tracking pixel after filmtrip
function loadTrackingPixel(trackPix) {
	const timestamp = new Date().getTime().toString();
	const trackPixWithTimeStamp = trackPix.replace("[timestamp]", timestamp);
	const trackImg = `<img src=${trackPixWithTimeStamp} height="1" width="1" alt="Advertisement">`;
	if (trackPix) {
		$(".filmStrip").append(trackImg);
	}
}
// Function to return truncated title for the article in filmstrip
function truncateArticleTitle(articleTitle) {
	if (articleTitle) {
		return articleTitle.length > 90 ? `${articleTitle.substring(0,90)}...` : articleTitle;
	}
}

// Function to reset the modal pop up
function resetEmailModalPopup() {
	let emailThisModalPopup = $('#js-email-this');
	let emailThisModalPopupStatus = emailThisModalPopup.find('.email-status');
	if(emailThisModalPopupStatus && emailThisModalPopupStatus.length) {
		emailThisModalPopupStatus.remove();
		emailThisModalPopup.find('.modal-content, .modal-footer').show();
	}
}

// Function to add leave us feedback 
function addLeaveUsFeedback() {
	const authCode = dpShareTools.checkAuthUser();
	if (authCode) {
		let articleContainer = $("#article-content");
		articleContainer.after('<div class="dp-feedback-link bottom"><span>Leave us Feedback</span></div>');
		articleContainer.before('<div class="dp-feedback-link top"><span>Leave us Feedback</span></div>');
		$(".info-layers").addClass("with-feedback");
		eventListnerForFeedbackPopup();
	}
}

function applyKeyTakeawaysStyle() {
	let transcriptContentParagraphs = $('#dp-transcript p');
	let transcriptContentParagraphsArray = (transcriptContentParagraphs) ? transcriptContentParagraphs.toArray() : [];
	if(transcriptContentParagraphsArray && transcriptContentParagraphsArray.length) {
		transcriptContentParagraphsArray.forEach((e) => {
			if(e.textContent && (e.textContent.toLowerCase().indexOf('key takeaways') > -1) && e.nextElementSibling && e.nextElementSibling.nodeName && e.nextElementSibling.nodeName.toLowerCase() == 'ul') {
				e.classList.add('dp-key-takeaways-p');
				e.nextElementSibling.classList.add('dp-key-takeaways-ul');
			}
		}) 
	}
}

// Function to add event listner for modal pop up
function eventListnerForFeedbackPopup() {
	$(".dp-feedback-link").on("click", function () {
		$(".email-modal").addClass("dp-feedback");
		$('#emailSenderName').val(emailThis.senderName);
		$('#emailSenderEmail').val(emailThis.senderEmail);
		$('#emailSubject').val(emailThis.title.substr(0, 70));
		$('#emailError').empty();
		$('#emailToEmail, #emailOptionalMessage, #feedbackMessage').val('');
		resetEmailModalPopup();
		showModal('js-email-this');
	});
	//click event to close the feedback modal
	$(document).on('click', '.email-modal.dp-feedback .close-modal', function () {
		$(".email-modal").removeClass('dp-feedback');
	});
	$('#feedbackSend').click(sendFeedbackValidate);
	
}

function sendFeedbackValidate() {
    var $email = $('#js-email-this');
    var copyMe = $('#emailCopyMe').is(':checked');
    var error = $('#emailError');
    var senderEmail = $('#emailSenderEmail').val();
	var hasError = false;
	var feedback = $('#feedbackMessage').val();
    error.empty();
    if ($('#emailSenderName').val() === '') {
        error.append($('#nameRequired').clone());
        hasError = true;
	}
	if (senderEmail === '') {
		error.append("<div>Please enter Your Email Address.</div>");
		hasError = true;
	} else if (senderEmail && isNotValidEmail(senderEmail)) {
		var emailInvalidMessage = $('#emailInvalidMessage');
		error.append(emailInvalidMessage.clone().text(senderEmail + ' ' + emailInvalidMessage.text().trim()));
		hasError = true;
	}
    
	if (feedback === '') {
		error.append("<div>Please enter Your Message.</div>");
        hasError = true;
	}
    if (hasError) {
        return;
    }
	// added QA email ID for testing
    var toEmailId = ["medscapefeedback@webmd.net"];
	// Sending email to dev and QA on QA01 environment
	if (getDomain().indexOf("qa01") >= 0 ) {
        toEmailId = ["rsingh@webmd.net","achopra@webmd.net","pthakre@webmd.net"];
	}
	// toEmailId.push($('#emailToEmail').val());
    
    var url = '//api.' + window.getDomain() + 'medscape.com/servicegateway/v2/auth/notificationservice/emailthis'

    var data = {
        workflow: 'medscape_ba_sharethis',
        toEmailId: toEmailId,
        params: {
            senderName: emailThis.senderName,
            senderEmail: emailThis.senderEmail,
            locale: emailThis.locale,
            pubName: emailThis.publicationName,
            pubDate: emailThis.publicationDate,
            subject: emailQuoteReplace($('#emailSubject').val()),
            linkURL: window.location.protocol + '//' + window.location.host + window.location.pathname,
            contentTitle: emailQuoteReplace(emailThis.title),
            contentId: DFPTargetKeys.pageSegVars.art,
            specialtyId: DFPTargetKeys.pageSegVars.ssp,
            isCme: 0,
            professionId: DFPTargetKeys.userSegVars.pf,
            message: emailQuoteReplace(feedback) || emailQuoteReplace(emailThis.title)
        }
    };

    $email.find('.modal-content, .modal-footer').hide();
    $email.find('.modal-header').after('<div class="email-status"><div class="spinner"></div></div>');

    $.ajax({
            type: 'POST',
            url: url,
            data: JSON.stringify(data),
            contentType: 'application/json;charset=utf-8',
            xhrFields: {
                withCredentials: true
            }
        })
        .done(function(data) {
            if (data.messages[0] === 'success') {
                $email.find('.modal-content, .modal-footer').hide();
                $email.find('.email-status').html($('#emailSendMessage').text());
            }
        })
}
function renderRelatedWidget(articles) {
	window.relatedArticles = articles;
	sticky.init();
	//TODO fix this carousel loading issue in a better solution
	if ($(".related-content").length > 0 ) {
		return;
	}
	// Add new carousel after video player that is the filmstrip
	let filmStripContainerHtml = "<div class='filmStrip'></div>";
	$('#videoContent').after(filmStripContainerHtml);
    
	const numOfVideo = articles === undefined ? 0: articles.length;
	const currentPath = getUrlParameter('path');
	if (!articles) {
    	throw "articles are undefined or null";
    }
    
    articles.forEach((item, index) => {
		const name = (item.firstName === null ? "" : item.firstName) 
					+ " " + (item.middleName === null ? "": item.middleName) 
					+ " " + (item.lastName === null ? "": item.lastName);
	 
		const thumbnailUrl = item.url;
		const articleTitleFull = item.articleTitle ; 
		const title = truncateArticleTitle(articleTitleFull);
		const duration = item.mediaDuration === null ? "" : item.mediaDuration;
		const articleUrl = location.origin + `${specialityUrl}/viewarticle/` + item.articleId;
		const guidelineUrl = articleUrl + '#guidelines';
		const subject = item.subject ===  null ? "" : item.subject;
		const transcriptUrl = articleUrl + '#transcript';
		const filmStripCardHtml = `<div class='filmStrip-card carousel-cell'>
		<div class='video-teaser'><a href="${articleUrl}" onclick="wmdTrackSafe(\'dp-rel_img\', this);"><img src=${thumbnailUrl} alt="${articleTitleFull}"></a></div>
		<a href=${articleUrl} onclick="wmdTrackSafe(\'dp-rel_title\', this);"><div class='filmStrip-card-title'>${playListApi.enhanceTitleForViewability(title) }</div></a>
		</div>`;
		$('div.filmStrip').append(filmStripCardHtml);
		if(index === articles.length - 1) {
			if(checkdirectIFI()) {
				addWatchListButton();
			}
		}
 	});
	if(($("#cme-video-player").length == 0) && ($('.streaming-video-container').length == 0)){
		$('.filmStrip').flickity(
			{	
				cellAlign: 'left',
				pageDots: false,
				draggable: false
			}
		);
	} 
	$('div.breadcrumb > a').promise().done(setGobackUrl());
	window.nextVideo = articles[0];
	const nextVideoUrl = location.origin + `${specialityUrl}/viewarticle/` + window.nextVideo["articleId"];
	sticky.setNextVideo(nextVideoUrl , window.nextVideo["articleTitle"]);
}

const getAllArticles = () => {
	const typeParam = getUrlParameter(typeUrlParam);
	const subTypeParam = getUrlParameter(subTypeUrlParam);
	
	if (typeParam && subTypeParam) {
		const articleUrl = BASE_URL_DP_SELECTION_PATH_API + typeParam.replace(/\+/g, ' ') + '/subtype/' + subTypeParam + '/articles?path=';
		let relatedArticles;
		$.ajax({
			url: articleUrl,
				success: function(result){
			        relatedArticles = result;
				}
		}).done(function() {
			if (relatedArticles.articles) {
				// Only show 10 articles per Chris
				renderRelatedWidget(relatedArticles.articles.splice(0, MAX_RELATED_ARTICLES));
			}
		});
	} else {
		 //
		 // If user hit the url like https://odp.qa01.medscape.com/viewarticle/896864, no url parameters, then
		 // we will need to query the cancer and tumor to construct the parameters and query for articles
		const articleId = getArticleIdFromUrl();
		renderRelatedArticlesForNoParamArticle(articleId);
	}
};

const getRelatedArticles = (articleId) => {
	const articleUrl =  BASE_URL_DP_ARTICLE_API + articleId + '/relatedarticles'  + getParamForRelatedWidget();
	let relatedArticles; //http://api.qa01.medscape.com/contentmetadataservice/decisionpoint/getrelated/896725
	$.ajax({ 
		url: articleUrl,
			success: function(result){
		        relatedArticles = result;
			}
	}).done(function() {
		if (relatedArticles && relatedArticles.articles.length === 0) {
			getAllArticles();
		} else {
			renderRelatedWidget(relatedArticles.articles.splice(0, MAX_RELATED_ARTICLES));
		}
	}).fail(function() {
	    console.log( "getarticle api call fails" );
	});
};


(function insertODPads() {
	if(profads.ads2.getBrkPnt === undefined) return;
    //if (DFPTargetKeys.reqHeaders.device == 'PC' || profads.ads2.getBrkPnt() === '1024-1279') {
        $('<div class="rightAd"><div id="ads-pos-909" class="AdUnit"></div></div>').insertBefore('#mostPopRight');
        webmd.ads2.defineAd({
            id: 'ads-pos-909',
            pos: '909'
        });
	//}
	if ((DFPTargetKeys.reqHeaders.device == "MOBILE" || profads.ads2.getBrkPnt() == "320-767") && DFPTargetKeys.webSegVars.pc == "content"){
		$("#abBottom").html('<div id="ads-pos-1122_f" class="AdUnit"></div><div id="ads-pos-1909" class="AdUnit"></div>');
				  webmd.ads2.defineAd({
					   id: 'ads-pos-1122_f',
					   pos: '1122'
				 });
				 webmd.ads2.defineAd({
					 id: 'ads-pos-1909',
					 pos: '1909'
				 }); 
	 }
})();
// Add read more related guidelines articles
function addGuidelinesReadMoreButton () { 
	$('.guidelines-list').children('.related-guideline').each(function() {
		$(this).find('div.morelink').before( "<span class='read-more'><span class='read-more-gradient'></span></span>" );
		$(this).find('div.morelink a').attr('onclick','wmdPageLinkSafe("dp-art_full", this);');
	});
}
function AddTitleAndAuthorInTabs() {
	//Getting the header and meta html
	let articleTitle = $(".title").html();
	let authorHtml = $(".meta").html();
	// Add title and author in transcript and related guideline tabs
	$("#dp-transcript").prepend(`<div class='meta'>${authorHtml}</div>`);
	$("#dp-transcript").prepend(`<h1>${articleTitle}</h1>`);
	$("#dp-guidelines").prepend(`<div class='meta'>${authorHtml}</div>`);
	$("#dp-guidelines").prepend(`<h1>${articleTitle}</h1>`);	
}
// Loading video player bundle for ODP
function addBundle(json, videoEl) {
	var vidConfigObj = json; // Fast Video
	vidConfigObj.config.duration = getDuration(vidConfigObj.config.duration);
	var fastVidBool = true;
	var tracking = {"moduleName": "vidodp", "toolin": "video - odp"};	
	
	if (typeof json.config != 'undefined') {
		vidConfigObj = json.config;
		fastVidBool = false;
	}
	
	vidConfigObj['videoId'] = 'video1';
	vidConfigObj = ccReconfig.reconfiguireCcConfig(json, "videoContent");  
	vidConfigObj['title'] = $("h1.title").text().length > 0 ?  $("h1.title").text() : "";
	
	/* Mappings for ODP video */
	if (!fastVidBool) {
		if (typeof vidConfigObj['poster'] != 'undefined') {
			vidConfigObj['poster'] = vidConfigObj['poster'].replace('en/pi','pi');
			window.currentThumbnail = 'https://img.' + getDomain() + 'medscapestatic.com/' + vidConfigObj['poster'];
		}
		if (typeof vidConfigObj['bumperImage'] != 'undefined') {
			vidConfigObj['bumperImage'] = vidConfigObj['bumperImage'].replace('en/pi','pi');
			window.currentThumbnail = 'https://img.' + getDomain() + 'medscapestatic.com/' + vidConfigObj['bumperImage'];
		}
		if (typeof s_sact !== "undefined") {
			tracking['activityId'] = s_sact.toString();
		}
	}
	/* /End Mappings for ODP video */
	
	if (typeof json.tracking != 'undefined' && Object.keys(json.tracking).length > 0) {
		$.extend(true, tracking, json.tracking);
	}
	
	let svpLoader = new SVPLoader();
	svpLoader.loadSVPLibrary().then(res => {
		if(checkdirectIFI()){
			let dp_DirectIfi = new DP_DirectIFI();
			dp_DirectIfi.init(videoEl, vidConfigObj, tracking);
		}else{
		window.myVideoPlayer = new Medscape.modules.StreamingVideoPlayer(videoEl, vidConfigObj, tracking);
		window.myVideoPlayer.create().then(event => {
			resolvePromise('video-loaded');
			$("#cme-video-player").css({ 'background-color' : '', 'min-height' : 'auto' });
			addNowPlayingVideo();
		},
		error => {
			videoEl.innerHTML = `<div class="error">Sorry, the video player failed to load.</div>`;
		});
		}
	})
}
// Promise to add now playing video after video load
var resolvePromise = null;
var videoLoadedPromise = new Promise(resolve => resolvePromise = resolve);

$(document).ready(function() {
 	specialityUrl = $("#dpTitleText").attr('data-url') ? $("#dpTitleText").attr('data-url') : "/oncology" ;
	// Editing the DOM according to the new designs
	//AddTitleAndAuthorInTabs();
	// Switching transcript and guidelines tabs
	$(document).on('click','#dp-tabs span', toggleTabsFromEvent);

	function toggleTabsFromEvent() {
	    if (!$(this).is('.opentab')) {
	    	const tabN = $(this).attr('id').split('-');
			$("#dp-tabs").children().removeClass('opentab');
			$(this).addClass('opentab');
			$("#article-content").children().hide();
			$("#dp-"+tabN[1]).show();
			if ($(this).attr('id') === "tab-transcript") {
			  //enableReadMoreButton();
			  $('span.show-more').show();
			  wmdPageLinkSafe('dp-art_trans', this);
			} else if ($(this).attr('id') === "tab-guidelines") {
			  wmdPageLinkSafe('dp-art_guide', this);
			}
	    } 
	}

	function triggerToggle (tab) {
	    $( "#tab-"+tab).trigger( "click" );
	}
	
	
	// Adding a Div in the dp-tabs to fix the translation issue
	$("#dp-tabs span").wrapInner('<div/>');

	// Apply the styling for KeyTakeaways
	applyKeyTakeawaysStyle();
 	
	// Add read more button in Related guidelines articles
	addGuidelinesReadMoreButton();
	
	dpShareTools.displaySocialShareTools();
	// Add send leave us feedback in bottom
	addLeaveUsFeedback();
	if(location.pathname.indexOf(`${specialityUrl}/viewarticle/`)>-1) {
		getRelatedArticles(location.pathname.replace(`${specialityUrl}/viewarticle/`, ''));
	} else {
		getRelatedArticles(location.pathname.replace(`/viewarticle/`, ''));
	}
	
	 //setTimeout(function(){ setGobackUrl(); }, 500);

	// Bind click events to the new read-more elements in related guidelines
	$('div.related-guideline .read-more').on('click', function(e) {
		if( $(this).prev('div.byline').hasClass('expanded')) {
			$(this).prev('div.byline').removeClass('expanded');
			$(this).removeClass('expanded');
		} else {
            $(this).prev('div.byline').addClass('expanded');
            $(this).addClass('expanded');
            wmdPageLinkSafe('dp-art_gread', this);
        }
	});

	(function() {
		if (window.location.hash !== '') {
			triggerToggle((window.location.hash).replace('#',''));
		  }
	})();

    if(profads.ads2.getBrkPnt === undefined) return; //ad blocker check
	if(DFPTargetKeys.reqHeaders.device == 'MOBILE' || profads.ads2.getBrkPnt() == '320-767') {
		scrollEvents.removeLazyLoadEvent();
	}

	// NON-FAST-VID
	var videoEl = document.getElementById('cme-video-player');
	if (videoEl != null && videoEl.getAttribute('data-config') != null && videoEl.getAttribute('data-config') != '' && document.getElementById('video-bundle') == null) {
		var configPath = document.getElementById('cme-video-player').getAttribute('data-config');
		$.ajax({
			url: '//api.' + getDomain() + 'medscape.com/contentservice/video/content/' + configPath, 
			jsonp: 'callback', 
			dataType: 'jsonp',  
			success: function(json) {
				addBundle(json, videoEl);
			}
		});
	}
	
});

export default class DecisonPoint {
	constructor() {
		Medscape.DecisonPoint = this;
		this.sponsoredVideoData = {}
	}
	loadSponsoredVideo (config = null) {
		try {
			const event = window.performance.mark('eedDP_800', {
				detail: "EED DP 800/1800 event called",
			});
            const performanceEntries = window.performance.getEntriesByType('mark');
			const marker = performanceEntries.find(entry => 
                entry.name === 'eedDP_start'
            );
			const record_dp = getMeasurementDuration(window.performance.measure('ifi event call time', 'eedDP_start', 'eedDP_800').duration);
            wmdPageLink(`vid-perf_ifi-${getMeasurementDuration(marker.startTime)}|${getMeasurementDuration(event.startTime)}`);
		} catch (error) {
			console.log(error);
		}
                
		if( config ) {
			window.sponsoredVideoData = config;
			window.sponsoredVideoData['video']['title'] = config.title ? config.title : "";
			let sponsoredVideoClass = "";
			if (config.title.length < 90) {
				sponsoredVideoClass = "";
			} else if (config.title.length >= 90 && config.title.length < 124) {
				sponsoredVideoClass = "ifi-120";
			} else if (config.title.length >= 124 && config.title.length < 144) {
				sponsoredVideoClass = "ifi-140";
			} else if (config.title.length >= 144 && config.title.length < 164) {
				sponsoredVideoClass = "ifi-160";
			} else if (config.title.length >= 164 && config.title.length < 184) {
				sponsoredVideoClass = "ifi-180";
			} else if (config.title.length >= 184 && config.title.length < 204) {
				sponsoredVideoClass = "ifi-200";
			} else if (config.title.length >= 204 && config.title.length < 224) {
				sponsoredVideoClass = "ifi-220";
			} else if (config.title.length >= 224 && config.title.length < 244) {
				sponsoredVideoClass = "ifi-240";
			} else {
				sponsoredVideoClass = "ifi-max";
			}
			const jobCode = config['playlist'].jobCode ? config['playlist'].jobCode : "";
			window.ifiVideoHtmlString = `<div class="filmStrip-card carousel-cell ifi-card ${sponsoredVideoClass}">
			<div class="label playing" style="display:none">NOW PLAYING</div>
			<div class="video-teaser"><img alt="${config.title}" src="${config.playlist.thumbnail}"></div>
			<div class="filmStrip-card-ifi"><span>INFORMATION FROM INDUSTRY</span></div>
			<div class="filmStrip-card-title">${ playListApi.enhanceTitleForViewability(config.title)  }</div>
			<div class="job-code"><span>${jobCode}</span></div>
			</div>`;
			const ifiVideoHtml = $(window.ifiVideoHtmlString);
			
			// Inserting IFI in already created filmstrip
			if ( window.filmStripCreated ){
				window.EEDflkty.insert( ifiVideoHtml, 1 );
			}
			else {
				window.injectIFIwithNowPlaying = true;
			}
			$(".ifi-card").on("click", function () {
				if (window.sponsoredVideoData.video.videoId != window.myVideoPlayer.amp.media.metadata.videoId) {
					$(".current-video .label.playing").hide();
					$(".ifi-card .label.playing").show();
					window.myVideoPlayer.setMedia(window.sponsoredVideoData.video);
					if (typeof window.sponsoredVideoData.video.trackingPixel == "string") {
						loadTrackingPixel(window.sponsoredVideoData.video.trackingPixel);
					}
					addIsiBeforeTheFilmStrip();
					$('.article-wrapper').hide();
					const nextVideoUrl = location.origin + `${specialityUrl}/viewarticle/` + window.nextVideo["articleId"];
					sticky.setStickyTitle(config,true);
					sticky.setNextVideo(nextVideoUrl, window.nextVideo["articleTitle"]);
				}
			});
			sticky.setIFIVideo(config.title, ".ifi-card");
		}		
	}
}
let decisionPoint = new DecisonPoint();



function autoPlayNextVideo () {
	           let article = window.nextVideo;
			   let articleId = article.length > 0 ? window.relatedArticles.indexOf(article.articleId) + 1 : window.relatedArticles[0].articleId	;
			   let nextVideoUrl = location.origin + `${specialityUrl}/viewarticle/` + articleId;
			   if (articleId) window.location.href = nextVideoUrl;
}
function getDuration (duration) {
	let minutes,seconds,hours
	if (duration.split(":").length == 3 ) {
		hours = duration.split(':')[0];
		minutes = duration.split(':')[1];
		seconds = duration.split(':')[2];
		return (+hours) * 60 * 60 + (+minutes) * 60 + (+seconds)+"";
	} else if (duration.split(":").length == 2) {
		minutes = duration.split(':')[0];
		seconds = duration.split(':')[1];
		return (+minutes) * 60 + (+seconds)+"";
	} else {
		return duration
	}
}

// to check whether url has ifi
function checkdirectIFI(){
	let searchparams = new URLSearchParams(window.location.search);
	return searchparams.has('ifi');
}
function addWatchListButton() {
	const applyVideoSaver = () => {
		getAllFilmstripCards();
		if(!checkdirectIFI()){
			getNowPlayingVideo();
		}
		setTimeout(() => {
			if (window.EEDflkty) {
				window.EEDflkty.reloadCells();
			}
		}, 500);
  	};
	const fabButtonLoad = new WatchListFabButton(applyVideoSaver);
	fabButtonLoad.init();
}

function getAllFilmstripCards() {
	try {
		const filmstripCards = document.querySelectorAll('.filmStrip-card:not(.current-video,.ifi-card)');
		filmstripCards.forEach((card) => {
			const url = card.querySelector('a').href;
			const thumbnail = card.querySelector('img').src;
			const title = card.querySelector('.filmStrip-card-title').textContent;
			const videoConfig = {
				isIfi: false,
				isPlaylist: true,
				playlist: {
					thumbnail,
					title
				},
				link: url.replace(window.origin,'')
			};
			addVideoSaver(videoConfig,card);
		});
		if(window.EEDflkty)  {
			window.EEDflkty.reloadCells();
		}
	}catch(err) {
		console.log(err);
	}
}

function getNowPlayingVideo() {
	try {
		const currentVideo = $('.filmStrip-card.current-video');
		if($(currentVideo).find('.save-icon').length === 0) {
			const config = {
				isIfi: false,
				isPlaylist: false,
				playlist: {
					thumbnail: $(currentVideo).find('img').attr('src'),
					title: $(currentVideo).find('.filmStrip-card-title').text()
				},
				link: window.location.pathname
			}
			addVideoSaver(config,currentVideo);
		}
	} catch(err) {
		console.log(err);
	}
}

function addVideoSaver(config, wrapper) {
	try {
		const videoSaver = new VideoSaver(config);
		videoSaver.init();
		if(videoSaver.saveIcon !== null) {
			wrapper.append(videoSaver.saveIcon);
		}
	} catch(err) {
		console.log(err);
	}
}

function getMeasurementDuration(measure) {
    if (measure) {
        return (measure / 1000).toFixed(2);
    }
    return null;
}
